export default __webpack_public_path__ + "static/media/pattern2.f1bc907f.svg";